module.exports = __webpack_public_path__ + "img/jg.7b447d58.png";